import { styled } from 'styled-components';

export const StyleConnectedWidgetContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const StyleInfoBox = styled.div`
  display: inline-block;

  border-radius: var(--pcm-rounded-lg);
  background: var(--pcm-body-background);
  box-shadow: var(--pcm-modal-box-shadow);
  max-width: 400px;
  vertical-align: middle;
  line-height: normal;
  padding: 5px 0px;
  box-sizing: content-box;
`;

export const StyleChainSection = styled.div<{ selected?: boolean }>`
  cursor: ${(props) => (props.selected ? 'pointer' : 'default')};
  display: inline-block;
  gap: 8px;
  height: 28px;
  margin: 0 10px;
  padding: 0 6px;
  border-radius: 6px;
  background-color: var(--pcm-body-background);
  transition: background-color 0.3s;

  ${(props) =>
    props.selected &&
    `
    &:hover {
      background-color: var(--pcm-body-background-secondary);
    }
  `}
  .wrap {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 100%;
  }
`;

export const StyleChainIcon = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
`;

export const StyleChainName = styled.div`
  font-size: 14px;
  line-height: 1;
  position: relative;
  top: -1px;
`;

export const StyleDivider = styled.div`
  display: inline-block;
  width: 1px;
  height: 19px;
  background: var(--pcm-secondary-button-bankground);
`;

export const StyleAddressSection = styled.div`
  display: inline-block;
  gap: 8px;
  height: 28px;
  margin: 0 10px;
  padding: 0 6px;
  border-radius: 6px;
  background-color: var(--pcm-body-background);
  transition: background-color 0.3s;
  position: relative;
  top: 3px;
  &:hover {
    background-color: var(--pcm-body-background-secondary);
  }
  .wrap {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 100%;
  }
`;

export const StyleIconWrapper = styled.div`
  width: 20px;
  height: 20px;
`;

export const StyleWalletAddress = styled.div`
  font-size: 14px;
`;

export const StyleSwitchNetwork = styled.div`
  font-size: 14px;
  color: var(--pcm-error-color);
  display: flex;
  gap: 6px;
  align-items: center;
`;
